import React, { Component } from 'react';
import Content from '../../components/Content';

class PravilaZaPolzvane extends Component {
  componentDidMount() {
    document.title = 'Правила за ползване - A1 Xplore TV GO';
  }

  render() {
    return <Content resource="PravilaZaPolzvane" />;
  }
}

export default PravilaZaPolzvane;
